import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    outline: { type: Boolean, default: false },
    label: {},
    disabled: { type: Boolean, default: false },
    type: { default: 'button' }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_md_outlined_button = _resolveComponent("md-outlined-button")!
  const _component_md_filled_tonal_button = _resolveComponent("md-filled-tonal-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.outline)
      ? (_openBlock(), _createBlock(_component_md_outlined_button, {
          key: 0,
          disabled: props.disabled,
          type: props.type,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.label) + " ", 1),
            _renderSlot(_ctx.$slots, "icon")
          ]),
          _: 3
        }, 8, ["disabled", "type"]))
      : _createCommentVNode("", true),
    (!props.outline)
      ? (_openBlock(), _createBlock(_component_md_filled_tonal_button, {
          key: 1,
          disabled: props.disabled,
          type: props.type,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('click')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.label) + " ", 1),
            _renderSlot(_ctx.$slots, "icon")
          ]),
          _: 3
        }, 8, ["disabled", "type"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})